/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.08.17.
 */

import React from "react";
import PropTypes from "prop-types";
import BaseController from "./BaseController";

import {NotFoundException} from "../../../Exceptions";

class TabbedViewController extends BaseController {
    static propTypes = {
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired
    };

    static defaultProps = {};

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.resource != this.props.params.resource || prevProps.params.id != this.props.params.id) this.loadData();
    }

    loadData() {
        // Load in resource and parent resource, if specified:
        this.loadResource();
    }

    getActionData(a) {
        if (this.state.resource)
            return this.state.resource.currentRecord;
        return null;
    }

    /**
     * Load in resource
     * @param {string} resourceField Resource store to load - eiter "resource" or "parentResource"
     * @param {string} id Resource id
     */
    loadResource() {
        if (this.props.params.id == null) return;
        let numericId = Number.parseInt(this.props.params.id, 10);
        if (isNaN(numericId)) throw new NotFoundException();
        // Test if already loaded:
        if (!this.isResourceLoaded()) this.actions().get.defer(this.props.params.id);
    }

    isResourceLoaded() {
        return (this.state.resource &&
            this.state.resource.currentRecord &&
            this.state.resource.currentRecord.id == this.props.params.id);
    }

    /**
     * If loading fails with 404 then show not found exception page.
     * @override
     * @param {string} key Store key
     * @param {BaseRestStoreState} newState Store state
     */
    loadingFailed(key, newState) {
        if (key === "resource" || key === "parentResource") {
            if (newState.action.method === "get" && newState.action.error.code === 404) throw new NotFoundException();
        }
    }

    /**
     *
     * @param {PageAction} action
     */
    onComponentAction(action) {
        if (this.state.resource.currentRecord) action.data = this.state.resource.currentRecord;
        return super.onComponentAction(action);
    }
}

export default TabbedViewController;
